export const WallpaperConfig = {
  adzerk: {
    // This is the endpoint where we retrieve the ads from
    api: 'https://e-10220.adzerk.net/api/v2',

    // Adzerk expects us to provide a list of ads types we want to retrieve.
    // The main adType is wallpaper, which will return the creatives we'll show within the iframe.
    // video ad type is used to retrieve VAST trackers.
    adTypes: {
      video: 3502,
      wallpaper: 959,
    },

    // Site identifier aka wetransfer.com
    siteId: 1055922,

    // WeTransfer account identifier
    networkId: 10220,

    // The placement where we show the ads.
    placements: {
      iframe: 'iframe',
      video: 'video',
    },
  },

  // Studio wallpapers are uploaded here.
  host: 'https://backgrounds.wetransfer.net/',

  // This endopint returns information about editorial wallpapers
  editorialUrl: 'https://editorial-wallpaper.wetransfer.com/',
  legacyEditorialUrl: 'https://wtplus.wetransfer.com/',

  // Default rotation interval in milliseconds
  defaultRotationInterval: 45000,

  // Rotation interval for plus backgrounds
  plusRotationInterval: 30000,

  // Define rotation intervals for ads:
  // 1..10: 45s
  // 11..25: 180s
  // 26..Infinity: 600s
  rotationIntervals: [[26, 600000], [11, 180000], [1, 45000]],

  // Sales define some "groups" of positions, to easily book campaigns.
  // Here we define the name of the slot, and the rotation positions where we will use it.
  rotationSlots: {
    // The key correspond with the Zone Id in Adzerk
    // https://app.adzerk.com/#!/site/1055922/zones/
    199071: [1, 1], // 1-Platinum
    199072: [2, 2], // 2-Platinum
    199073: [3, 3], // 3-Platinum
    199074: [4, 4], // 4-Platinum
    199075: [5, 5], // 5-Platinum
    199076: [6, 6], // 6-Gold
    199077: [7, 7], // 7-Gold
    199078: [8, 8], // 8-Gold
    199079: [9, 9], // 9-Gold
    199080: [10, 10], // 10-Gold
    199081: [11, 11], // 11-Silver
    199082: [12, 12], // 12-Silver
    199083: [13, 13], // 13-Silver
    199084: [14, 14], // 14-Silver
    199085: [15, 15], // 15-Silver
    199086: [16, 20], // 16-Bronze
    199087: [21, 25], // 21-Copper
    199088: [26, Infinity], // 26-Iron
  },

  // When something goes really wrong, show fallback wallpaper
  fallback: {
    src: 'brand/1905/fallback_v3/index.html',
    rotationInterval: 10000,
  },

  // Animation settings
  transition: {
    duration: 1000,
    easing: 'ease',
  },

  format: {
    get IMAGE() {
      return 'image';
    },
    get HTML5() {
      return 'html5';
    },
    get VIDEO() {
      return 'video';
    },
  },

  dev: {
    enabled: __DEV__ && __WALLPAPER_DEV_ENABLED__ === true,
    // Provide as many wallpapers as needed.
    // The `src` property must point to an existing resource, html or image.
    // creatives: [
    //   {
    //     format: 'image',
    //     src: 'https://backgrounds.wetransfer.net/poulomi2_1280x800.jpg',
    //     meta: {
    //       title: 'Paulomi Basu',
    //       href: 'https://wepresent.wetransfer.com/story/poulomi-basu/',
    //     },
    //   },
    //   {
    //     format: 'video',
    //     src:
    //       'https://backgrounds.wetransfer.net/shutterstock/1803/interactive_generic_refresh_nl_v1/assets/videos/video-02.mp4',
    //     meta: {
    //       title: 'Uploaded by Plus user',
    //     },
    //   },
    // ],
    creatives: [],
  },
};
